export default {
      id: "Icon--arrowDown-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--arrowDown",
      toString: function () {
        return this.url;
      }
    }